export const getNumericPhoneNumber = (phoneNumber?: string) => {
    return phoneNumber?.replace(/\D/g, ""); // removes all non-numeric characters
};
